import type { Alert, TrackingStatus } from '@api';

import type { EventAlertsPaginatedResponse } from './event-alerts-query-keys';

export const updateKgInsightAlertTrackingStatus = ({
  data,
  entityTag,
  trackingStatus,
}: {
  data: EventAlertsPaginatedResponse;
  entityTag: string;
  trackingStatus: TrackingStatus;
}): EventAlertsPaginatedResponse => {
  let hasChanges = false;
  const pages = data.pages.map(page => {
    if (!page.alerts) {
      return page;
    }

    let hasPageChanges = false;
    const alerts = page.alerts.map((alert: Alert) => {
      const shouldUpdate =
        alert.source_type === 'kg-insight' &&
        alert.metadata?.entity_tag === entityTag &&
        alert.tracking_status !== trackingStatus;

      if (!shouldUpdate) {
        return alert;
      }

      hasChanges = true;
      hasPageChanges = true;
      return { ...alert, tracking_status: trackingStatus };
    });

    return hasPageChanges ? { ...page, alerts } : page;
  });

  return hasChanges ? { ...data, pages } : data;
};
